var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page page-home"},[_c('div',{staticClass:"title"}),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.$router.replace('/game')}}}),_vm._v(" "),_c('div',{staticClass:"tips"})])
}
var staticRenderFns = []

export { render, staticRenderFns }